import { getContainer } from '@mews-commander/legacy-app-instance';
import { Substitutes } from '@mews/framework';

/** @deprecated use LocalizedText or useLocalizeText */
export const localizeText = (text: Mews.TextKey, substitutes?: Substitutes): string => {
    const container = getContainer();
    const { appLocalizationComponent } = container();

    return appLocalizationComponent.localizeText(text, substitutes);
};
